/**
 * @description Retrieve the path of a URL by removing the
 * trailing slash and query parameters
 *
 * @param {string} url - The URL to retrieve the path from
 * @returns {string} The URL path
 *
 * @example
 * const url = "/path/?query=123";
 * const urlPath = getUrlPath({ url });
 * console.log(urlPath); // Output: "/path"
 */
function getUrlPath({ url }) {
  if (!url) {
    return '';
  }

  return url.split('?')[0].replace(/\/+$/, '');
}

export default getUrlPath;
